<template>
  <b-modal
      v-model="isOpen"
      centered
      size="lg"
      modal-class="history-preview-modal"
      header-class="history-preview-modal__header"
      body-class="history-preview-modal__body"
      footer-class="history-preview-modal__footer"
      hide-header-close
  >
    <template #modal-title>
      <div class="hm-title">
        <div class="hm-title__icon">
          <feather-icon icon="ClockIcon" size="18" />
        </div>
        <div class="backgrou">تاریخچه وفاداری کاربر</div>
      </div>
    </template>

    <div v-if="histories.length" class="history-modal-content">
      <b-table
          striped
          hover
          responsive
          class="mb-0"
          :items="histories"
          :fields="tableFields"
      >
        <template #cell(targetDate)="data">
          {{ formatYearMonth(data.value) }}
        </template>

        <template #cell(scheduleTotal)="data">
          {{ formatNumber(data.value) }} دقیقه
        </template>

        <template #cell(groupClassTotal)="data">
          {{ formatNumber(data.value) }} دقیقه
        </template>

        <template #cell(termicClassTotal)="data">
          {{ formatNumber(data.value) }} دقیقه
        </template>

        <template #cell(supportTotal)="data">
          {{ formatNumber(data.value) }} دقیقه
        </template>

        <template #cell(allTime)="data">
          <b-badge variant="dark">
            {{ formatNumber(data.value) }} دقیقه
          </b-badge>
        </template>
      </b-table>
    </div>

    <div v-else class="text-center py-4 text-muted">
      هیچ تاریخچه‌ای برای این کاربر یافت نشد.
    </div>

    <template #modal-footer>
      <div class="hm-footer">
        <div class="text-muted">
          {{ histories.length }} مورد یافت شد
        </div>
        <b-button variant="success" @click="isOpen = false">
          بستن
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BTable, BButton, BBadge } from "bootstrap-vue";

export default {
  name: "HistoryPreviewModal",

  components: { BModal, BTable, BButton, BBadge },

  props: {
    value: { type: Boolean, default: false },
    histories: { type: Array, default: () => [] }
  },

  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },

    tableFields() {
      return [
        { key: "targetDate", label: "تاریخ" },
        { key: "levelName", label: "سطح" },
        { key: "scheduleTotal", label: "کلاس ساعتی" },
        { key: "groupClassTotal", label: "کلاس گروهی" },
        { key: "termicClassTotal", label: "کلاس ترمیک" },
        { key: "supportTotal", label: "پشتیبانی" },
        { key: "allTime", label: "کل فعالیت" }
      ];
    }
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },

    formatNumber(v) {
      return new Intl.NumberFormat("fa-IR").format(Number(v || 0));
    },

    formatYearMonth(v) {
      const d = new Date(v);
      return isNaN(d) ? "—" : d.toLocaleDateString("fa-IR", { year: "numeric", month: "long" });
    }
  }
};
</script>

<style scoped>
.history-modal :deep(.modal-content) {
  border: none;
  border-radius: 24px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.22);
  overflow: hidden;
  direction: rtl;
}

.history-modal__header {
  padding: 18px 20px;
  background: linear-gradient(135deg, #16a34a, #15803d);
  color: #fff;
  border-bottom: none;
}

.history-modal__body {
  padding: 18px 20px;
  background: #fff;
}

.history-modal__footer {
  padding: 14px 20px;
  background: #fff;
  border-top: 2px solid #ecfdf5;
}

.hm-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.hm-title__icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hm-title__text {
  font-size: 17px;
  font-weight: 900;
}

.hm-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.history-modal-content {
  max-height: 60vh;
  overflow-y: auto;
}
</style>